import { Button } from "@mui/material";
import React, { useEffect } from "react";
import useEnhancedNavigate, { injectTikTokScript, removeTikTokScript } from "./Session/helpers";

export default function ThankYou() {
  const navigate = useEnhancedNavigate();

  useEffect(() => {
    // Inject the script when the component mounts
    injectTikTokScript()
    return () => {
      // Remove the script when the component unmounts
      removeTikTokScript();
    };
  }, [])
  
  return (
    <div className="flex items-center flex-col w-full justify-center h-screen bg-white">
      <div className="flex flex-col items-center space-y-10 max-w-[350px]">
        <h1 className="text-[28px] font-bold text-[#1C1C1E] font-['Inter'] text-center">
          Your new subscription is ready
        </h1>
        <p className="text-center font-['Inter'] font-normal">
          You will receive a{" "}
          <span className="font-['Inter'] font-semibold">welcome email</span>{" "}
          and an{" "}
          <span className="font-['Inter'] font-semibold">invoice email</span>{" "}
          once payment is successful.
        </p>

        <Button
          onClick={() => navigate("/chat")}
          variant="contained"
          className="w-[295px] h-[46px] text-white font-inter text-[16px] font-normal leading-[22px] tracking-[-0.43px] !normal-case !bg-[#1C1C1E]"
        >
          Continue to TradeGPT
        </Button>
      </div>
    </div>
  );
}
